import router from "@/router";
import Cookies from 'js-cookie';
import { usePermissionStore } from '@/stores/usePermissionStore';

const whiteList = [
    "/auth/login",
    "LinkView",
];

router.beforeEach(async (to, _, next) => {
    const token = Cookies.get("mat");
    const permissionStore = usePermissionStore();

    if (!token) {
        // Clear permissions if no token
        permissionStore.clearPermissions();

        // @ts-ignore
        if (whiteList.includes(to.path) || whiteList.includes(to.name)) {
            next();
        } else {
            next("/auth/login");
        }
        return;
    }

    // Load permissions from token if not already loaded
    if (!permissionStore.isAuthenticated) {
        permissionStore.loadPermissions();
    }

    // Check route permission if specified
    if (to.meta.permission) {
        const requiredPermission = to.meta.permission as string;
        const hasPermission = permissionStore.hasPermission(requiredPermission);

        if (hasPermission) {
            next();
        } else {
            console.warn(`Access denied to ${to.path}: missing permission ${requiredPermission}`);
            next("/403");
        }
    } else {
        next();
    }
});